module.exports = __webpack_public_path__ + "static/img/icon-edit-profile.c19763a.png";